import React from 'react'
import Subtitle from '../../../../components/subtitle';
import Text from '../../../../components/text';
import { IRegistros } from '../../../../@interfaces';

interface IProps {
  data: IRegistros;
}

const CardRegistroMobile: React.FC<IProps> = ({ data }) => {
  return (
    <div className="w-full rounded-xl border border-gray-100 bg-white overflow-hidden shadow-sm mb-3">
      <div className="px-5 pt-3.5 pb-2 border-b border-gray-100 flex items-center gap-3">
        <Text className="!text-[14px] !font-semibold">{data.nome}</Text>
      </div>

      <div className="bg-[#F3F4F6] mx-4 mt-3 mb-1 px-4 pt-2.5 pb-3 rounded-md flex justify-between max-[500px]:grid max-[500px]:grid-cols-2 max-[500px]:gap-y-3">
        <div>
          <Subtitle className="!text-[#4C7AFB] !text-[11px]">Entrada</Subtitle>
          <Text className="!text-[14px] !font-semibold">{data.entrada || '—'}</Text>
        </div>

        <div className="text-center max-[500px]:text-right">
          <Subtitle className="!text-[#47CC64] !text-[11px]">S. Ref</Subtitle>
          <Text className="!text-[14px] !font-semibold">{data.saidaRefeicao || '—'}</Text>
        </div>

        <div className="text-center max-[500px]:text-left">
          <Subtitle className="!text-[#e07a5f] !text-[11px]">R. Ref</Subtitle>
          <Text className="!text-[14px] !font-semibold">{data.retornoRefeicao || '—'}</Text>
        </div>

        <div className="text-right">
          <Subtitle className="!text-[#ffa62b] !text-[11px]">Saída</Subtitle>
          <Text className="!text-[14px] !font-semibold">{data.saida || '—'}</Text>
        </div>
      </div>

      <div className="flex justify-end px-5  py-3 items-center">
        <Text className="!font-black !text-[12px]">RE: {data.rE}</Text>
      </div>
    </div>
  );
};

export default CardRegistroMobile;
